/**
 * A galeria viva do Axis Insights (/dev/insights-gallery) existe em toda base
 * MENOS producao — a mesma regra do `emit-sample` do motor
 * (`src/modules/insights/dev/emit-sample.ts`): la, o nome do pod pode mentir
 * mas o banco nao; aqui, a tela nao conhece banco, e o que nao mente e o
 * ENDERECO DO MOTOR que ela foi compilada para chamar (`VITE_ENGINE_URL`).
 *
 * Falha FECHADA: endereco ausente ou vazio → galeria desligada. A regra da
 * chave (ZERO-H) nao e ferida: `VITE_ENGINE_URL` e endereco de servico, nao
 * interruptor de comportamento — e o mesmo dado que o resto da tela ja le.
 */
import { HOSTS_DE_PRODUCAO } from '../../../lib/config'

export function galeriaHabilitada(enderecoDoMotor: string | undefined): boolean {
  if (typeof enderecoDoMotor !== 'string' || enderecoDoMotor.trim() === '') return false
  let host: string
  try {
    host = new URL(enderecoDoMotor).host.toLowerCase()
  } catch {
    return false
  }
  return !HOSTS_DE_PRODUCAO.some((h) => host === h || host.endsWith(`.${h}`))
}
